import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI';
import { isEmpty } from 'lodash'
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line, Legend, ResponsiveContainer} from 'recharts'
import { splitNumber } from '../../../utils/utility'

class LineGraphicSection extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.state={
			active: ""
		}
	}
	render() {
		const COLORS = ['#050505', '#1C4456', '#3888AB', '#87B7CD', '#AFCFDD'];
		const numberFormater = (num) => {
			return splitNumber(num + '')()
		}
		// const CustomizedLabel = React.createClass({
		// 	render() {
		// 		const { x, y, stroke, value } = this.props;
		// 		return <text x={x} y={y} dy={-4} fill={stroke} fontSize={12} textAnchor="middle">
		// 			{splitNumber(value + '')()}</text>
		// 	}
		// });

		const CustomizedTooltip = React.createClass({
			render() {
				const { active } = this.props;
				if (active) {
					const { payload, label, formatter } = this.props
					return (
						<div className="recharts-default-tootip no-margin p-10" style={{background:'#FFFCDC' ,border:"solid 1px #ccc"}}>
							<p className="recharts-tooltip-label no-margin">{label}</p>
							<ul className="recharts-tooltip-item-list no-padding no-margin">
								<li className="recharts-tooltip-item" 
									style={{display: "block", paddingTop:"4px", paddingBottom:"4px", color: payload ? payload[0].stroke : "#FFF"}}>
									<span className="recharts-tooltip-item-name">{ payload && payload[0] ? payload[0].name : ""}</span>
									<span className="recharts-tooltip-item-separator"> : </span>
									<span className="recharts-tooltip-item-value">{payload && payload[0] ? formatter(payload[0].value) : ""}</span>
								</li>
								<li className="recharts-tooltip-item"
									style={{display: "block", paddingTop:"4px", paddingBottom:"4px", color: payload[1].stroke}}>
									<span className="recharts-tooltip-item-name">{payload[1].name}</span>
									<span className="recharts-tooltip-item-separator"> : </span>
									<span className="recharts-tooltip-item-value">{payload && payload.length > 1 ? formatter(payload[1].value) : ""}</span>
								</li>
								{
									payload.length > 2 && (
										<li className="recharts-tooltip-item"
											style={{display: "block", paddingTop:"4px", paddingBottom:"4px", color: payload[2].stroke}}>
											<span className="recharts-tooltip-item-name">{payload[2].name}</span>
											<span className="recharts-tooltip-item-separator"> : </span>
											<span className="recharts-tooltip-item-value">{payload && payload.length > 2 ? formatter(payload[2].value) : ""}</span>
										</li>										
									)
								}
							</ul>
						</div>
					)
				}

				return null
			}
		})

		const { title, data, subTitle, dataNames, dataKeys } = this.props
		if (isEmpty(data)){
			return (
				<div >
					<div style={{ fontSize: '16px', lineHeight: '18px', marginBottom: '20px', fontWeight:'bold' }}>{title}</div>

					<div style={{ width: '100%', minHeight: '200px', textAlign: 'center', paddingTop: '60px', color: "#CDCDCD" }}>
						<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
					</div>
				</div>
			)
		}
		
		return (
			<div >
				<div style={{ fontSize: '16px', lineHeight: '18px', marginBottom: '20px', fontWeight:'bold' }}>{title}</div>
				<ResponsiveContainer width="100%" height="80%" minHeight={200}>
				{
					dataKeys.length === 2 ? 
					<LineChart data={data}
						margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
						<XAxis dataKey="time" padding={{ left: 30, right: 30 }} />
						<YAxis yAxisId="left" label={{ value: dataNames[0], style:{ textAnchor: 'end' }, angle: -90, offset:0, position: 'insideTopLeft' }} />
       			<YAxis yAxisId="right" label={{ value: dataNames[1], style:{ textAnchor: 'start' }, angle: 90, offset:0, position: 'insideTopRight' }} orientation="right" />
						<CartesianGrid strokeDasharray="3 3" vertical={false} />
						<Tooltip formatter={numberFormater} content={<CustomizedTooltip />} />
						<Legend layout="horizontal" verticalAlign="top" align="center" />
						<Line yAxisId="left" isAnimationActive={this.props.animation} name={dataNames[0]} type="monotone" dataKey={dataKeys[0]} strokeWidth={2} stroke={dataKeys.length > 2 ? COLORS[0] : COLORS[1]} activeDot={{ r: 6 }} />
						<Line yAxisId="right" isAnimationActive={this.props.animation} name={dataNames[1]} type="monotone" dataKey={dataKeys[1]} strokeWidth={2} stroke={dataKeys.length > 2 ? COLORS[1] : COLORS[2]} activeDot={{ r: 5 }} />
					</LineChart> :				
					<LineChart data={data}
						margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
						<XAxis dataKey="time" padding={{ left: 30, right: 30 }} />
						<YAxis />
						<CartesianGrid strokeDasharray="3 3" vertical={false} />
						<Tooltip formatter={numberFormater} content={<CustomizedTooltip />} />
						<Legend layout="vertical" verticalAlign="top" align="right" />
						<Line isAnimationActive={this.props.animation} name={dataNames[0]} type="monotone" dataKey={dataKeys[0]} strokeWidth={2} stroke={dataKeys.length > 2 ? COLORS[0] : COLORS[1]} activeDot={{ r: 6 }} />
						<Line isAnimationActive={this.props.animation} name={dataNames[1]} type="monotone" dataKey={dataKeys[1]} strokeWidth={2} stroke={dataKeys.length > 2 ? COLORS[1] : COLORS[2]} activeDot={{ r: 5 }} />
						{dataKeys.length > 2 && <Line isAnimationActive={this.props.animation} name={dataNames[2]} type="monotone" dataKey={dataKeys[2]} strokeWidth={2} stroke={COLORS[2]} activeDot={{ r: 4 }} />}
					</LineChart>
				}
				</ResponsiveContainer>
				<div className="text-center">
					<strong>{subTitle}</strong> <span>{this.props.subTitleText}</span>
				</div>
			</div>
		)
	}
}

LineGraphicSection.propTypes = {
	title: React.PropTypes.string.isRequired,
	data: React.PropTypes.array,
	subTitle: React.PropTypes.string,
	subTitleText: React.PropTypes.string,
	dataNames:React.PropTypes.array,
	dataKeys: React.PropTypes.array
}

LineGraphicSection.defaultProps = {
	dataNames: ["Messages", "Engagement"],
	dataKeys: ["messages", "engagement"]
}

export default LineGraphicSection


// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/LineGraphic.jsx